import React from 'react';
import { Header } from '@hz-design-system/web-ui';
import type { THeaderConfig } from '@hz-design-system/web-ui/lib/types/THeaderConfig';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';

import '../../../scss/global.scss';

import { trackGAEvent } from '../../utils/gaTracking';

import CreateAccountApp from '../../apps/CreateAccountApp/CreateAccountApp';
import { TEnvironmentContext } from 'types/EnvironmentContext';

export default (i18n: any) => {
  const environment: TEnvironmentContext = window.__ENV_CONFIG__ || ({} as TEnvironmentContext);
  if (!environment.isEmbeddedInMobileApp) {
    const headerConfig: THeaderConfig = window.__HEADER_CONFIG__ || ({} as THeaderConfig);
    const headerContainer = document.getElementById('header-root');
    // Header is server side rendered in express-react library
    hydrateRoot(headerContainer!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);
  }

  const createAccountRoot = createRoot(document.getElementById('create-account-app-root')!);

  createAccountRoot.render(
    <I18nContextProvider i18nInstance={i18n}>
      <CreateAccountApp environment={environment} />
    </I18nContextProvider>,
  );
};
